<!-- Prikazi listu fizickih lica sa sve search-om -->
<kodit-page>
  <kodit-table
    [tableConfig]="tableConfig"
    [items]="fizickaLicaTable"
    [chipItems]="chipItems"
  >
  </kodit-table>
</kodit-page>
